import AccessTime from '@mui/icons-material/AccessTime';
import { Typography } from '@qbe/ads-core';
import React from 'react';

import Modal from '~/components-ds/Modal';
import { useAppContent } from '~/hooks';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onRestart: () => void;
}

export const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ isOpen, onRestart }) => {
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.idleUserTimer',
  });

  return (
    <Modal
      id="session-expired-modal"
      analyticsModalName="session expired modal"
      open={isOpen}
      title={getTextContent('fields.sessionExpiredModal.title')}
      iconProps={{
        muiIcon: AccessTime,
        color: '#d43900',
      }}
      primaryBtnProps={
        {
          label: getTextContent('buttons.restart'),

          onClick: onRestart,
          'data-track': 'restart',
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any
      }
    >
      <Typography>{getJSXContent('fields.sessionExpiredModal.description')}</Typography>
    </Modal>
  );
};
